import React from 'react';
import Modal from '../base/Modal';
import { ZapOff, Info } from 'lucide-react'; // Using the 'ZapOff' icon

const LoopBreakNodeModal = ({ mode, node, onSave, onDelete, onClose }) => {

    const handleSave = () => {
        onSave({
            ...node,
            data: {
                label: 'Loop Break',
            },
        });
    };

    return (
        <Modal title="Configure Loop Break Node" isOpen={true} onClose={onClose}>
            <div className="p-6 bg-zinc-900 rounded-b-lg text-center">

                <div className="flex justify-center items-center mb-5">
                    <div className="p-4 bg-zinc-800 rounded-full">
                        <ZapOff className="w-12 h-12 text-rose-400" />
                    </div>
                </div>

                <h3 className="text-xl font-semibold text-white mb-2">Loop Break Point</h3>
                <p className="text-zinc-400 mb-6 max-w-sm mx-auto">
                    This node stops a loop from an "Unwrap Array" node by merging its parallel branches back into a single path.
                </p>

                <div className="bg-zinc-800/50 border border-zinc-700 p-3 rounded-lg flex items-start gap-3 text-left">
                    <Info className="w-5 h-5 text-zinc-500 shrink-0 mt-0.5" />
                    <p className="text-sm text-zinc-400">
                        This control node does not produce any data output.
                    </p>
                </div>

                <div className="flex justify-end gap-3 mt-8">
                    {mode === "edit" && (
                        <button
                            className="px-4 py-2 text-zinc-300 bg-red-800 hover:bg-red-700 rounded-md transition-colors"
                            onClick={() => onDelete(node.id)}
                        >
                            Delete Node
                        </button>
                    )}
                    {
                        mode === "add" && (<button
                            className="px-4 py-2 text-white bg-blue-600 hover:bg-blue-700 rounded-md transition-colors"
                            onClick={handleSave}
                        >
                            Add Node
                        </button>)
                    }

                </div>
            </div>
        </Modal>
    );
};

export default LoopBreakNodeModal;